export const MODULE_NAME = 'lk-mun-meh-form'


export const LK_MUN_MEH_FORM_ROUTES = {
  LAYOUT: MODULE_NAME,
  FORM: `${MODULE_NAME}.form`,
  ANY_LEVEL: `${MODULE_NAME}.form.level`,
} as const
